export default "__VITE_ASSET__SRdutKnY__"